// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__Xfm4j","modal":"denied_modal__Qi-+u","bounce":"denied_bounce__Ytr1V","overlay":"denied_overlay__SRxJl","wrapper":"denied_wrapper__XglcK"};